import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import {
  AppDatePicker,
  AppMultiSelect,
  AppRemixIcon,
} from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import Translator from '../../../../components/helpers/Translator';
import { axiosPath, path } from '../../../../../routing/helpers/router';
import { getLogFilterInitialValues } from '../../../../../minions/forms';
import AuxSidebar from '../../../../Sidebar/AuxSidebar';
import useIsMounted from '../../../../components/hooks/useIsMounted';
import ResponsibleSelect from '../../../../components/form/Selects/ResponsibleSelect';

export default function LogFilterSidebarBlock() {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const { moduleBridgeHex, filtersHex } = useParams();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const filters = useSelector((state) => state.currentPage?.logFilters);
  const [openOnce, setOpenOnce] = useState(true);
  const [typeOptions] = useState([
    { value: 0, label: 'Nuevo Riesgo' },
    { value: 1, label: 'Riesgo editado' },
    { value: 2, label: 'Riesgo eliminado' },
    { value: 3, label: 'Valoración de Riesgo editado' },
    { value: 4, label: 'Nuevo Control' },
    { value: 5, label: 'Control editado' },
    { value: 6, label: 'Control eliminado' },
    { value: 7, label: 'Revisión Control editada' },
    { value: 8, label: 'Revisión Control validada' },
    { value: 9, label: 'Revisión Control archivo descargado' },
    { value: 10, label: 'Nuevo Plan de acción' },
    { value: 11, label: 'Plan de acción editado' },
    { value: 12, label: 'Plan de acción eliminado' },
    { value: 13, label: 'Revisión Plan de acción editada' },
    { value: 14, label: 'Revisión Plan de acción validada' },
    { value: 15, label: 'Revisión Plan de acción archivo descargado' },
    { value: 16, label: 'Nuevo Proceso' },
    { value: 17, label: 'Proceso editado' },
    { value: 18, label: 'Proceso eliminado' },
  ]);

  const handleAuxSidebar = () => {
    if (!openOnce) setOpenOnce(true);
    if (auxSidebar !== 'filters') {
      dispatch(currentPageAction.change('auxSidebar', { opened: 'filters' }));
    } else {
      dispatch(currentPageAction.change('auxSidebar', { opened: null }));
    }
  };

  const goToLogs = (hexCode) =>
    navigate(
      path({
        name: 'user_module_totalEnergiesRisk_log_list',
        params: {
          moduleBridgeHex,
          page: 1,
          filtersHex: hexCode,
        },
      })
    );

  // > GENERATE FILTER HEX CODE
  const generateFilterHexCode = async (values, setSubmitting) =>
    axios
      .post(
        axiosPath(
          'api_r_user_module_totalEnergiesRisk_risk_generateFilterHexCode'
        ),
        { moduleBridgeHex, filters: values }
      )
      .then(({ data }) => {
        setSubmitting(false);
        goToLogs(data.hexCode);
        dispatch(currentPageAction.change('auxSidebar', { opened: null }));
      });

  const handleOnSubmit = (values, { setSubmitting }) => {
    generateFilterHexCode(values, setSubmitting);
  };
  // < GENERATE FILTER HEX CODE

  // > FILTERS
  const getFilters = useCallback(
    async () =>
      axios
        .post(
          axiosPath('api_r_user_module_totalEnergiesRisk_risk_getFilters'),
          {
            moduleBridgeHex,
            filtersHex,
          }
        )
        .then(({ data }) => {
          if (isMounted.current) {
            dispatch(currentPageAction.change('logFilters', data));
          }
        }),
    [moduleBridgeHex, filtersHex]
  );

  useEffect(() => {
    if (filtersHex !== '0') {
      getFilters();
    } else {
      dispatch(
        currentPageAction.change(
          'logFilters',
          getLogFilterInitialValues(),
          true
        )
      );
    }
  }, [filtersHex]);
  // < FILTERS

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'filters' ? 'active' : ''}
        onClick={() => handleAuxSidebar()}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="equalizer" className="sidebar-icon" />{' '}
          <span className="sb-title">
            <Translator file="module-legalCompliance" name="filtering" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={<Translator file="module-legalCompliance" name="filtering" />}
        isOpen={auxSidebar && auxSidebar === 'filters'}
        width="350px"
        position="right"
        onClose={handleAuxSidebar}
      >
        {openOnce && (
          <>
            {filters && (
              <Formik
                validateOnChange={false}
                validateOnBlur={false}
                enableReinitialize
                initialValues={filters}
                onSubmit={handleOnSubmit}
              >
                {({
                  setFieldValue,
                  handleSubmit,
                  values,
                  errors,
                  isSubmitting,
                }) => (
                  <>
                    <div className="d-flex mt-3 mb-3">
                      <span
                        className="btn btn-info btn-block"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                      >
                        <Translator
                          file="module-legalCompliance"
                          name="filtering"
                        />
                      </span>
                      {filtersHex !== '0' && (
                        <span
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="delete.filters"
                            />
                          )}
                          className="btn btn-outline-danger ml-1"
                          onClick={() =>
                            navigate(
                              path({
                                name: 'user_module_totalEnergiesRisk_log_list',
                                params: {
                                  moduleBridgeHex,
                                  page: 1,
                                  filtersHex: 0,
                                },
                              })
                            )
                          }
                        >
                          <AppRemixIcon icon="delete-bin-6" />
                        </span>
                      )}
                    </div>
                    <AppDatePicker
                      title="Fecha desde"
                      value={values?.dateFrom}
                      onChange={(opt) => setFieldValue('dateFrom', opt)}
                      isClearable
                      showYearDropdown
                      showMonthDropdown
                    />
                    <AppDatePicker
                      title="Fecha hasta"
                      value={values?.dateTo}
                      onChange={(opt) => setFieldValue('dateTo', opt)}
                      isClearable
                      showYearDropdown
                      showMonthDropdown
                    />
                    <ResponsibleSelect
                      title="Usuarios"
                      value={values.userBridges}
                      error={errors?.userBridges}
                      onHandleChange={(opt) =>
                        setFieldValue('userBridges', opt)
                      }
                      apiCall="api_r_user_module_totalEnergiesRisk_control_getResponsibles"
                      hasSearchBox
                      isClearable
                    />
                    <AppMultiSelect
                      options={typeOptions}
                      title="Descripción"
                      value={values.types}
                      error={errors?.types}
                      onChange={(opt) => setFieldValue('types', opt)}
                      hasSearchBox
                      hasSelectOptions
                      isClearable
                    />
                  </>
                )}
              </Formik>
            )}
          </>
        )}
      </AuxSidebar>
    </>
  );
}
